module.exports = __webpack_public_path__ + "img/saleimg.33278667.png";